/** Visual tokens shared by Phaser views and fallback art (DOM overlay mirrors them in CSS). */
/** The game font, then the Vietnamese fallback (ui/styles.css, fetched only when such characters render; see glyphs.ts). */
export const FONT = '"Fredoka Variable", "Fredoka", "Noto Sans Vi", ui-rounded, "SF Pro Rounded", "Nunito", system-ui, sans-serif';

export const C = {
  ink: 0x4a2c2a,
  inkSoft: 0x7a5646,
  cream: 0xfff8ec,
  creamDeep: 0xf3e2c6,
  tileEdge: 0xd9b98f,
  tileShadow: 0x8a6446,
  sky: 0xffe6bf,
  skyDeep: 0xffc98a,
  tomato: 0xff6b5b,
  tomatoDark: 0xc94a3d,
  teal: 0x2ec4b6,
  tealDark: 0x1f8f84,
  mustard: 0xffc845,
  mustardDark: 0xd99a1c,
  mint: 0x8fe3a8,
  grape: 0x8e6cef,
  white: 0xffffff,
  black: 0x000000,
  kraft: 0xe9b57a,
  kraftDark: 0xc98a4b,
  gem: 0x4cc9f0,
  coin: 0xffcf3f,
  star: 0xffc400,
  danger: 0xff4d4d,
} as const;

export function css(c: number): string {
  return '#' + c.toString(16).padStart(6, '0');
}

/** Item colours: 11 hues that stay distinct for common colour-vision types when paired with shapes. */
export const ITEM_COLORS = [
  0xff5a5f, 0xff9f1c, 0xffd23f, 0x3bb273, 0x2ec4b6, 0x3a86ff, 0x8338ec, 0xff70a6, 0xa0522d, 0x1d3557, 0x9be564,
] as const;

/**
 * The journey's teaser street (views/journey.ts drawSilhouette): muted sky, a skyline of fixed
 * blocks (widths as a share of the column, heights as a share of the vista; no randomness),
 * ground, road and shop plots. The DOM next-city card (features/citycards) draws the same street,
 * so the tokens live here, where a view chunk can read them without Phaser.
 */
export const SILHOUETTE = {
  sky: [0xd5dde4, 0xc6ced6],
  ground: 0xaab7a1,
  skyline: 0x9d9fb4,
  skylineFoot: 0x8e8ca3,
  road: 0xe1dccf,
  plot: 0x8a8298,
  blocks: [0.1, 0.16, 0.08, 0.14, 0.12, 0.18, 0.09, 0.13],
  tall: [0.5, 0.8, 0.35, 0.65, 0.45, 0.9, 0.4, 0.6],
} as const;
